export const CONFIRMATION_MODAL_TYPES = {
  defaultConfirmation: "default",
  removeItemsConfirmation: "removeItemsConfirmation",
  removeItemsConfirmationSendToOthers: "removeItemsConfirmationSendToOthers",
};

export const { defaultConfirmation, removeItemsConfirmation, removeItemsConfirmationSendToOthers } =
  CONFIRMATION_MODAL_TYPES;

export const CONFIRMATION_MODAL_TYPES_HEADER_MAPPING = {
  [defaultConfirmation]: "Are you sure?",
  [removeItemsConfirmation]: "Are you sure you want to remove all the items from the bag?",
  [removeItemsConfirmationSendToOthers]:
    "Are you sure you want to remove all items from the bag for the selected country?",
};
